import axios from "axios";

const proxyUrlRaw = process.env.REACT_APP_NZBN_PROXY_URL;
const proxyKeyRaw = process.env.REACT_APP_NZBN_PROXY_KEY;

// Debounce utility function
function debounce<T extends (...args: any[]) => any>(
    func: T,
    wait: number
): (...args: Parameters<T>) => Promise<ReturnType<T>> {
    let timeout: NodeJS.Timeout | null = null;

    return function (...args: Parameters<T>): Promise<ReturnType<T>> {
        return new Promise((resolve, reject) => {
            if (timeout) clearTimeout(timeout);

            timeout = setTimeout(async () => {
                try {
                    const result = await func(...args);
                    resolve(result);
                } catch (error) {
                    reject(error);
                }
            }, wait);
        });
    };
}


export interface BusinessEntity {
    label: string;
    value: string;
    info: {
        status: string;
        registrationDate: string;
        nzbn: string;
    };
}

function mapNzbnItem(item: any): BusinessEntity {
    return {
        label: item.entityName || item.name || item.label || "",
        value: `${item.entityName || item.name || item.label || ""}, NZBN: ${item.nzbn || item.NZBN || ""}`,
        info: {
            status: item.entityStatusDescription || item.status || item.entityStatus || "",
            registrationDate: item.registrationDate,
            nzbn: item.nzbn || item.NZBN || ""
        }
    };
}

// Internal implementation without debounce
async function searchEntitiesInternal(searchTerm: string, no?: string): Promise<BusinessEntity[]> {

    if (!searchTerm) return [];
    const extractItems = (data: any) => {
        if (Array.isArray(data)) return data;
        if (Array.isArray(data.items)) return data.items;
        if (Array.isArray(data.results)) return data.results;
        return [];
    };

    try {
        // const url = `${proxyUrlRaw}/?code=${proxyKeyRaw}&searchTerm=${encodeURIComponent(searchTerm)}`;
        // const res = await axios.get(url, { headers: { accept: "application/json" } });
        if (!proxyUrlRaw) throw new Error("Missing REACT_APP_NZBN_PROXY_URL");
        if (!proxyKeyRaw) throw new Error("Missing REACT_APP_NZBN_PROXY_KEY");

        // sanitize and ensure a string type for TS
        const proxyKey = proxyKeyRaw.replace(/^"|"$/g, "");

        const res = await axios.get(proxyUrlRaw, {
            params: { code: proxyKey, search: searchTerm },
            headers: { accept: "application/json" }
        });
        const items = extractItems(res.data);
        if (!Array.isArray(items)) throw new Error("Unexpected response format");
        return items.map(mapNzbnItem);
    } catch (err) {
        return Promise.reject(err);
    }
}

// Export debounced version as the main entry point (300ms delay)
export const searchEntities = debounce(searchEntitiesInternal, 300);